import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import type { ConversationActionWithAssistantMetadata } from './action-capabilities';
import { getConversationActionWithAssistantMetadata } from './getConversationActionWithAssistantMetadata';

export const getActionSeededConversationOptions = (
	action: ConversationAction | undefined,
): ConversationActionWithAssistantMetadata['seededConversation'] =>
	getConversationActionWithAssistantMetadata(action)?.seededConversation;
